import { useEffect, useState } from 'react';
import { ChatLoading } from 'bv-components';

const ChatPreloaderView = () => {
  const [liveChatIsLoading, setLiveChatIsLoading] = useState(false);

  const hideChatPreloader = () => {
    setLiveChatIsLoading(false);
  };

  const liveChatIsOpened = () => {
    if (!window.zE) return false;
    const display = window.zE('webWidget:get', 'display');
    return !!display && display !== 'hidden';
  };

  useEffect(() => {
    window.addEventListener('zE_show_preloader', () => {
      const chatIsOpened = liveChatIsOpened();

      if (!chatIsOpened) {
        setLiveChatIsLoading(true);
      }
    }, false, { once: true });

    window.addEventListener('zE_hide_preloader', () => {
      let liveChatLoadingTime = 0;
      const hidePreloaderInterval = setInterval(() => {
        liveChatLoadingTime += 750;
        const chatIsOpened = liveChatIsOpened();
        if (chatIsOpened) {
          hideChatPreloader();
          clearInterval(hidePreloaderInterval);
        } else if (liveChatLoadingTime >= 30000) {
          clearInterval(hidePreloaderInterval);
        }
      }, 750);
    }, false, { once: true });
  }, []);

  return liveChatIsLoading ? (
    <ChatLoading onHideChatPreloader={hideChatPreloader} />
  ) : null;
};

export default ChatPreloaderView;
